'use strict';

module.exports = function() {
    var eventCallBack = function(eventType) {
        var tcVars = window.tc_vars;
        if (Odigeo._.isFunction(window.usabilla_live)) {
            tcVars.in_usabilla_exit_var = eventType.type === Odigeo.Events.mouseLeave ? 1 : 0;
            window.usabilla_live('data', {
                'custom': Odigeo._.assign({}, tcVars),
            });
        }
    };

    var $body = $('body');
    $body.on(Odigeo.Events.mouseLeave + ' ' + Odigeo.Events.mouseEnter, eventCallBack);
};
